import { APP_VERSION } from './types';
import _ from "lodash";

const LOCAL_CONSTANT = {
    PRIVILEGE_ATTERIBUTE: "privilegeAttribute",
    GROUP: "GROUP",
}

export const setAppVersionDefault = () => {
    return {
        type: APP_VERSION.SET_APP_VERSION_DEFAULT,
    }
}

export const setAppVersion = (appVersion) => {
    return {
        type: APP_VERSION.SET_APP_VERSION,
        appVersion: appVersion
    }
}

export const setAppVersionValue = (draftType, orignalProduct, key, value, index) => {
    const appVersion = _.cloneDeep(orignalProduct);
    appVersion[draftType] = value;
    
    return {
        type: APP_VERSION.SET_APP_VERSION_VALUE,
        appVersion: appVersion
    }
}
